import RaiseFundsCaseDetails from './RaiseFundsCaseDetails'

export default RaiseFundsCaseDetails
